/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Compiler, Injector, NgModuleFactory } from '@angular/core';
import {

  HttpEvent,
  HttpHeaders,
  HttpRequest,
} from '@angular/common/http';
import { BehaviorSubject, Observable, Subject, ReplaySubject } from 'rxjs';
import {
  Calendar,
  Calender,
  Category,
  Channel,
  Client,
  Distributor,
  FbChannel,
  FbForecast,
  Item,
  ItemAccount,
  Measure,
  Source,
  UserFbForecast,
  Version,
} from '@algomusinc/domain';
import { Form } from '@angular/forms';
import { EnvironmentService } from '../service/service.module';

@Injectable({
  providedIn: 'root'
})
export class PlannerService {
environment = EnvironmentService.environment

constructor(public http: HttpClient) { }

//Subjects
public plannerReportRenderer = new BehaviorSubject<any>(null);
public updateGridList = new BehaviorSubject<any>(null);
public updateWeeks = new BehaviorSubject<any>(null);
public openImportDialog = new BehaviorSubject<any>(null);
public savedPlannerOpened = new BehaviorSubject<any>(null);
public removeMenu = new BehaviorSubject<any>(null);
public updateForecastList = new BehaviorSubject<any>(null);

// Observables
public updateGridList$ = this.updateGridList.asObservable();
public updateWeeks$ = this.updateWeeks.asObservable();
public openImportDialog$ = this.openImportDialog.asObservable();
public savedPlannerOpened$ = this.savedPlannerOpened.asObservable();
public removeMenu$ = this.removeMenu.asObservable();
public updateForecastList$ = this.updateForecastList.asObservable();


public gridList: any[] = [];
public menuList: any[] = [];
public agGridClass = 'ag-theme-material';

AccountSettingMappingGetList(params: any): Observable<any> {
  return this.http.get<any>(
    `${this.environment.AppAccountSettingMapping}/GetList`,
    { params }
  );
}
calendarGetList(params: any): Observable<Calendar[]> {
  return this.http.get<Calendar[]>(
    `${this.environment.AppFBForcast}/calendarGetList`,
    { params }
  );
}
DataManagerMeasuresGetList(params: any): Observable<any> {
  return this.http.get<any>(
    `${this.environment.AppFBForcast}/dataManagerMeasuresGetList`,
    {
      params,
    }
  );
}
DefaultAddRefresh(params: any) {
  return this.http.post<any>(
    `${this.environment.AppFBSpreading}/DefaultAddRefresh`,
    params
  );
}

FbForecastApplyMeasureProfile(params: any): Observable<any> {
  return this.http.put<any>(
    `${this.environment.FbForecastProfile}/Applied`,
    params
  );
}

FBForecastCommitAsync(FbForecast: any): Observable<any> {
  return this.http.post<any>(
    `${this.environment.AppFBForcast}/FBForecastCommitAsync`,
    FbForecast
  );
}

FBForecastCommit(FbForecast: any): Observable<boolean> {
  return this.http.post<boolean>(
    `${this.environment.AppFBForcast}/FBForecastCommit`,
    FbForecast
  );
}

FbForecastDefaultAdd(params: any): Observable<any> {
  return this.http.post(
    `${this.environment.AppFBForcast}/fbForecastDefaultAdd`,
    params
  );
}

fbForecastDefaultDelete(params: any): Observable<any> {
  return this.http.post(
    `${this.environment.AppFBForcast}/fbForecastDefaultDelete`,
    params
  );
}

FbForecastGetMeasureProfileList(params: any): Observable<any> {
  return this.http.get<any>(`${this.environment.FbForecastProfile}/getlist`, {
    params,
  });
}

FbForecastGetMeasurePermissionList(url: any): Observable<any> {
  return this.http.get<any>(
    `${this.environment.FbForecastProfile}/getMeasurePermissionlist?${url}`
  );
}

fbForecastGetPerformance(params: any) {
  return this.http.post<any>(
    `${this.environment.AppFBForcast}/fbForecastGetPerformance`,
    params
  );
}
fbForecastGetQuadrantView(params: any) {
  return this.http.post<any>(
    `${this.environment.AppFBForcast}/fbForecastGetQuadrantView`,
    params
  );
}

FbForecastPlannerCopyMeasure(params: any): Observable<any> {
  return this.http.post(
    `${this.environment.AppFBForcast}/PlannerCopyMeasure`,
    params
  );
}

FbForecastPlannerCopyMeasureAsync(params: any): Observable<any> {
  return this.http.post(
    `${this.environment.AppFBForcast}/PlannerCopyMeasureAsync`,
    params
  );
}

FbForecastSaveMeasureProfile(params: any): Observable<any> {
  return this.http.post<any>(
    `${this.environment.FbForecastProfile}/add`,
    params
  );
}
FbForecastSpreadingAddList(params: any): Observable<any> {
  return this.http.post(
    `${this.environment.AppFBSpreading}/spreadingAddList`,
    params
  );
}

GetItemSettings(params: any): Observable<any> {
  return this.http.post<any>( `${this.environment.AppItemManager}/GetItemSettings`, params);
}

getLiveReports(params: any): Observable<any> {
  return this.http.get(`${this.environment.AppMenu}/getLiveReports`, {
    params,
  });
}

GetUserSession(params: any): Observable<FbForecast> {
  return this.http.post<FbForecast>(
    `${this.environment.AppFBForcast}/fBForecastGetUserSession`,
    params
  );
}

ItemAccountGetAll(url: any): Observable<any> {
  return this.http.get<any>(
    `${this.environment.AppItemManager}/ItemAccountGetAll?${url}`
  );
}


ItemManagerGetAll(url: any): Observable<any> {
  return this.http.get<any>(
    `${this.environment.AppItemManager}/ItemManagerGetAll?${url}`
  );
}

measuresGetList(params: any): Observable<Measure[]> {
  return this.http.get<Measure[]>(
    `${this.environment.AppFBForcast}/measuresGetList`,
    { params }
  );
}

ProductSettingMappingGetList(params: any): Observable<any> {
  return this.http.get<any>(
    `${this.environment.AppProductSettingMapping}/GetList`,
    { params }
  );
}

userFBForecastAdd(FbForecast: any): Observable<number> {
  return this.http.post<number>(
    `${this.environment.AppFBForcast}/userFBForecastAdd`,
    FbForecast
  );
}

userFBForecastDeleteByVersionID(fbForecast: any) {
  return this.http.post<boolean>(
    `${this.environment.AppFBForcast}/UserFBForecastDeleteByVersionID`,
    fbForecast
  );
}

userFBForecastGetList(params: any): Observable<UserFbForecast[]> {
  return this.http.get<UserFbForecast[]>(
    `${this.environment.AppFBForcast}/userFBForecastGetList`,
    { params }
  );
}

userFBForecastUpdate(FbForecast: any): Observable<number> {
  return this.http.put<number>(
    `${this.environment.AppFBForcast}/userFBForecastUpdate`,
    FbForecast
  );
}

MeasureUpdate(FbForecast: any){
  return this.http.put<any>(
    `${this.environment.AppFBForcast}/MeasureUpdate`,
    FbForecast
  );
}

userItemForecastGetList(params: any): Observable<UserFbForecast[]> {
  return this.http.get<UserFbForecast[]>(
    `${this.environment.AppItemForcast}/userItemForecastGetList`,
    { params }
  );
}



// Unique Services


AccountSettingMappingDistributorGetList(params: any): Observable<any> {
  return this.http.get<any>(
    `${this.environment.AppAccountSettingMapping}/DistributorGetListByCountryId`,
    { params }
  );
}

fbForecastGetPerformanceRI(params: any) {
  return this.http.post<any>(
    `${this.environment.AppFBForcast}/fbForecastGetPerformanceRI`,
    params
  );
}

FbForecastSpreadingAdd(params: any): Observable<any> {
  return this.http.post(
    `${this.environment.AppFBSpreading}/SpreadingAdd`,
    params
  );
}

FbForecastSpreadingAddDisti(params: any): Observable<any> {
  return this.http.post(
    `${this.environment.AppFBSpreading}/SpreadingAddDisti`,
    params
  );
}

FbForecastSpreadingAddListAsync(params: any): Observable<any> {
  return this.http.post(
    `${this.environment.AppFBSpreading}/spreadingAddListAsync`,
    params
  );
}

FbForecastSpreadingAddListDisti(params: any): Observable<any> {
  return this.http.post(
    `${this.environment.AppFBSpreading}/spreadingAddListDisti`,
    params
  );
}

GetItemSettingsByDisti(params: any): Observable<any> {
  return this.http.get<any>(
    `${this.environment.AppItemManager}/GetItemSettingsByDisti`,
    {
      params,
    }
  );
}

SpreadingForecastAddCommitMeasures(FbForecast: any): Observable<boolean> {
  return this.http.post<boolean>(
    `${this.environment.AppFBSpreading}/SpreadingForecastAddCommitMeasures`,
    FbForecast
  );
}
UserPlannerSelectionAdd(params: any){
  return this.http.post<any>(
    `${this.environment.AppFBForcast}/UserPlannerSelectionAdd`,
    params
  );
}
GetUserPlanner(params: any) {
  return this.http.get<any>(
    `${this.environment.AppFBForcast}/UserPlannerSelectionGetByUserId`,
    { params }
  );
}
UserPlannerSelectionUpdate(FbForecast: any) {
  return this.http.put(
    `${this.environment.AppFBForcast}/UserPlannerSelectionUpdate`,
    FbForecast
  );
}
GetClassificationByIds(params: any): Observable<any> {
  return this.http.post(
    `${this.environment.AppCommonCode}/GetClassificationByIds`,
    params
  );
}
GetFbTemplates = () => {
  return this.http.get<any>(`${this.environment.AccountHierarchy}/GetFbTemplates`)
}
}
